export const breadcrumbsTheme = {
  textSize: '--medkit-breadcrumbs-text-size',
  linkColor: '--medkit-breadcrumbs-link-color',
  itemColor: '--medkit-breadcrumbs-item-color',
}
